module.exports = __webpack_public_path__ + "img/Wing_feathers_DiffuseColor.1bb5c3e.png";